export default [
  {
    title: 'menu.home',
    icon: 'mdi-home',
    link: '/',
    rolesAllowed: ['COACH'],
  },
  {
    title: 'trainingsession.menu.main',
    icon: 'mdi-presentation',
    link: '/trainingsession',
    shortcut: { home: true },
    rolesAllowed: ['COACH'],
  },
  {
    title: 'animation.menu.main',
    icon: 'mdi-animation-play',
    link: '/animation',
    shortcut: { home: true },
    rolesAllowed: ['COACH'],
  },
  {
    title: 'player.menu.main',
    icon: 'mdi-account-multiple',
    link: '/players',
    shortcut: { home: true },
    rolesAllowed: ['COACH'],
  },
  {
    title: 'menu.params',
    icon: 'mdi-table-edit',
    rolesAllowed: ['PARAMS'],
    children: [
      {
        title: 'multiproject.menu.main',
        icon: 'mdi-chart-gantt',
        link: '/multiproject',
      },
      {
        title: 'multitask.menu.main',
        icon: 'mdi-grid',
        link: '/multitask',
      },
      {
        title: 'networkdiagram.menu.main',
        icon: 'mdi-format-list-numbered',
        link: '/networkdiagram',
      },
      {
        title: 'ontime.menu.main',
        icon: 'mdi-timer',
        link: '/ontime',
      },
    ],
  },
  {
    title: 'menu.admin',
    icon: 'mdi-cogs',
    rolesAllowed: ['ADMIN'],
    children: [
      {
        title: 'menu.mycompany',
        icon: 'mdi-domain',
        link: '/my-company',
        shortcut: { home: true },
      },
      {
        title: 'menu.users',
        icon: 'mdi-account-group',
        link: '/users',
        shortcut: { home: true },
      },
      {
        title: 'menu.tokens',
        icon: 'mdi-checkbox-multiple-marked-circle',
        link: '/tokens',
        shortcut: { home: true },
      },
    ],
  },
  {
    title: 'menu.companies',
    icon: 'mdi-contacts',
    link: '/companies',
    shortcut: { home: true },
    rolesAllowed: ['MASTER'],
  },
]
